import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
  imageUpload,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import ContactDetailField from "../../molecules/ContactDetailField";
import Input from "../../atoms/Input";
import DynamicText from "../../molecules/DynamicText";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import PrintComponent from "../PrintComponent";
import DeliveryReceiptDownload from "./ClientSide/download";
import editIcn from "../../../imgs/edit.png";
import trashIcn from "../../../imgs/trash.png";
import LoadingModal from "../../molecules/LoadingModal";
import moment from "moment";
import MySignatureCanvas from "../../molecules/signature_canvas";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import CommentIcon from '@mui/icons-material/Comment';
import GavelIcon from '@mui/icons-material/Gavel';

const DeliveryReceiptPage = () => {
  const { surveyId, id, flg , org} = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    fileRef: "",
    clientName: "",
    clientEmail: "",
    clientSign: "",
    organization: org,
    originAddress: "",
    destinationAddress: "",
    commodity: "",
    noOfPackages: "",
    modeOfShippment: "",
    weightVolume: "",
    truckNo: "",
    container: "",
    remarks: "",
    adminSign: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isShare, setIsShare] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.originAddress = `${response?.data?.data?.surveyDetail?.loadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.loadPlaceCity}, ${response?.data?.data?.surveyDetail?.loadPlaceCountry}`;
        values.destinationAddress = `${response?.data?.data?.surveyDetail?.unloadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.unloadPlaceCity}, ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
        values.clientName = `${response?.data?.data?.surveyDetail?.name}`;
        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.fileRef = `${response?.data?.data?.surveyDetail?.id}`;

        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.originAddress = `${response?.data?.data?.loadPlaceStAddress}, ${response?.data?.data?.loadPlaceCity}, ${response?.data?.data?.loadPlaceCountry}`;
          values.destinationAddress = `${response?.data?.data?.unloadPlaceStAddress}, ${response?.data?.data?.unloadPlaceCity}, ${response?.data?.data?.unloadPlaceCountry}`;
          values.clientName = `${response?.data?.data?.name}`;
          values.clientEmail = `${response?.data?.data?.email}`;
          values.fileRef = `${response?.data?.data?.id}`;

          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  const [uploadText, setUploadText] = useState("Upload Sign");

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage("Delivery Receipt has been added successfully!");
        setOpenSnackbar(true);

        setTimeout(() => {
          navigate(-1);
          setIsLoading(false);
        }, 1000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage("Delivery Receipt has been updated successfully!");
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      });
  };

  useEffect(() => {
    if (flg == "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  //
  const shareWithClient = () => {
    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: [formContent?.clientEmail],
      formRoute: "delivery-receipt",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Delivery Receipt has been shared with client successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };


  //
  const uploadFile = async (file) => {
    setIsLoading(true);
    setUploadText("Uploading...");
    handleOpen();
    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };

        if (
          formContent?.adminSign != null &&
          formContent?.adminSign?.trim()?.length != 0
        ) {
          let dlt = [...mediaKeysToRemove];
          dlt.push(values.adminSign);
          setMediaKeysToRemove(dlt);
        }
        values.adminSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
        setUploadText("Upload Sign");
        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText("Upload Sign");

        setIsLoading(false);
        handleClose();
      });
  };

  const [isSignCanvas, setSignCanvas] = useState(false);

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  // Actions for the page header
  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => sendEditRequestToAdmin()}
          disabled={isEditLoading}
          startIcon={<NoteAltIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Edit
        </Button>
      )}

      {!isEdit && (
        <Button
           variant="outlined"
          onClick={() => shareWithClient()}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            border: "1px solid var(--glass-border)",
            color: "var(--text-main)",
            '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
          }}
        >
          Share
        </Button>
      )}

      {isEdit && flg == "2" && (
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
           sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (flg == "1") addContent();
            else updateContent();
          }}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 32px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            const tempTitle = document.title;
            const newTitle = `Delivery-Receipt-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
            document.title = newTitle;
            
            // Standardized delay for print and title restoration
            setTimeout(() => {
              window.print();
              setTimeout(() => {
                document.title = tempTitle;
              }, 2000);
            }, 500);
          }}
          disabled={isLoading}
          startIcon={<DescriptionIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--text-main)",
             boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
             '&:hover': { backgroundColor: '#000' }
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout 
        title="Delivery Receipt" 
        actions={pageActions} 
        onBack={() => navigate(-1)}
      >
        <PremiumCard>
          {/* Section 1: Basic Information */}
          <SectionHeader 
            title="General Information" 
            icon={<PersonIcon />} 
            iconBg="#e3f2fd"
            iconColor="#1976d2"
          />
          <div className="mb-4 no-print">
            <div className="contact-detail d-flex mt-4">
              {/* left col */}
              <div
                className={`left-col ${
                  !isEdit ? " w-50" : "w-50 pe-5"
                } text-start`}
              >
                <Typography variant="body1" gutterBottom>
                  <ContactDetailField
                    label="File Ref"
                    isEdit={isEdit}
                    type="text"
                    minWidth={"120px"}
                    value={formContent?.fileRef}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.fileRef = e.target.value;
                      setFormContent(values);
                    }}
                    disabled
                  />
                  <ContactDetailField
                    label="Customer"
                    isEdit={isEdit}
                    type="text"
                    minWidth={"120px"}
                    value={formContent?.clientName}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.clientName = e.target.value;
                      setFormContent(values);
                    }}
                    disabled
                  />
                </Typography>
              </div>
              {/* right col */}
              <div
                className={`right-col ${
                  !isEdit ? "w-50" : "w-50 ps-5"
                }  d-flex flex-column align-items-end pe-2`}
              >
                <div
                  className=""
                  style={isEdit ? { width: "-webkit-fill-available" } : {}}
                >
                  <Typography
                    variant="body1"
                    className="text-start w-100"
                    gutterBottom
                  >
                    <ContactDetailField
                      label="Date"
                      isEdit={isEdit}
                      type="date"
                      wrapperStyle="justify-content-start"
                      minWidth={"150px"}
                      value={formContent?.date}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.date = e.target.value;
                        setFormContent(values);
                      }}
                    />
                    <ContactDetailField
                      label="Organization"
                      isEdit={isEdit}
                      type="text"
                      wrapperStyle="justify-content-start"
                      minWidth={"150px"}
                      value={formContent?.organization}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.organization = e.target.value;
                        setFormContent(values);
                      }}
                    />
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          
          
           {/* Section 2: Shipment Details */}
          </PremiumCard>
          <SectionHeader 
            title="Shipment Details" 
            icon={<LocalShippingIcon />} 
            iconBg="#e0f2f1"
            iconColor="#00695c"
          />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <div className="mt-4 no-print">
          {/*  Origin Address */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Origin Address
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.originAddress
                      ? formContent?.originAddress
                      : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="originAddress "
                    type="text"
                    label="Origin Address"
                    style="full-border-field"
                    value={formContent?.originAddress}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.originAddress = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* / Origin Address */}
          {/*  Destination Address */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Destination Address
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.destinationAddress
                      ? formContent?.destinationAddress
                      : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="estinationAddress"
                    type="text"
                    label="Destination Address"
                    style="full-border-field"
                    value={formContent?.destinationAddress}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.destinationAddress = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /Destination Address */}
          {/*  Commodity */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Commodity
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.commodity ? formContent?.commodity : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="cmmodity"
                    type="text"
                    label="Commodity"
                    style="full-border-field"
                    value={formContent?.commodity}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.commodity = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /Commodity */}
          {/*  No of Packages */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    No. of Packages
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.noOfPackages
                      ? formContent?.noOfPackages
                      : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="noOfPackages"
                    type="text"
                    label="No of Packages"
                    style="full-border-field"
                    value={formContent?.noOfPackages}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.noOfPackages = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /No of Packages */}
          {/*  Mode of Shipment */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Mode of Shipment
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.modeOfShippment
                      ? formContent?.modeOfShippment
                      : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="modeOfShipment"
                    type="text"
                    label="Mode of Shipment"
                    style="full-border-field"
                    value={formContent?.modeOfShippment}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.modeOfShippment = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /Mode of Shipment */}
          {/*  Weight/Volume */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Weight/Volume
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.weightVolume
                      ? formContent?.weightVolume
                      : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="WeightVolume"
                    type="text"
                    label="Weight/Volume"
                    style="full-border-field"
                    value={formContent?.weightVolume}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.weightVolume = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /Weight/Volume*/}
          {/*  Truck No */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Truck No.
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.truckNo ? formContent?.truckNo : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="truckNo"
                    type="text"
                    label="Truck No"
                    style="full-border-field"
                    value={formContent?.truckNo}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.truckNo = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /Truck No*/}
          {/*  Container */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Container
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.container ? formContent?.container : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="Container"
                    type="text"
                    label="Container"
                    style="full-border-field"
                    value={formContent?.container}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.container = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
          </div>
          {/* /Container*/}
          {/*  Remarks */}
          </div>
            {/* Section 3: Additional Remarks */}
            </PremiumCard>
            <SectionHeader 
             title="Additional Remarks" 
             icon={<CommentIcon />} 
             iconBg="#f3e5f5"
             iconColor="#8e24aa"
           />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <div className="mt-4 pe-1 mb-5 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex justify-content-between">
                <div className="w-50">
                  <label htmlFor="packingDate" className="fw-bold">
                    Remarks
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text w-50 text-end">
                    {formContent?.remarks ? formContent?.remarks : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="truckNo"
                    type="text"
                    label="Remarks"
                    style="full-border-field"
                    value={formContent?.remarks}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.remarks = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr />
          </div>
          {/* /Remarks*/}

          {/* Signatures */}
          </PremiumCard>
          <SectionHeader title="Approvals" icon={<GavelIcon />} />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <Row className="my-5 pt-5 no-print">
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent?.adminSign?.trim()?.length == 0 ? (
                  <>
                    {isEdit && (
                      <div className="d-flex justify-content-center align-items-end">
                        <label
                          htmlFor="uploadSign"
                          className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                        >
                          {uploadText}
                        </label>
                        <input
                          type="button"
                          hidden
                          id="uploadSign"
                          name="uploadSign"
                          onClick={() => {
                            setSignCanvas(true);
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex align-items-start">
                    <img
                      src={`${Bucket}${formContent?.adminSign}`}
                      height={80}
                      width={200}
                    />

                    {isEdit && (
                      <>
                        <label
                          htmlFor="editSign1"
                          className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                        >
                          <img
                            src={editIcn}
                            height={18}
                            width={18}
                            className="ms-2 cursor-pointer"
                          />
                        </label>
                        <input
                          type="button"
                          hidden
                          id="editSign1"
                          name="uploadSign"
                          onClick={() => {
                            setSignCanvas(true);
                          }}
                        />
                        <img
                          src={trashIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            let keysToDelete = [...mediaKeysToRemove];
                            keysToDelete.push(formContent?.adminSign);
                            setMediaKeysToRemove(keysToDelete);

                            let values = { ...formContent };
                            values.adminSign = "";
                            setFormContent(values);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>

              <p>{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Authorized Signature"}</b>
              </p>

              {""}
            </Col>
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                <div className="d-flex align-items-center justify-content-center text-center">
                  {formContent?.clientSign && (
                    <img
                      src={`${Bucket}${formContent.clientSign}`}
                      height={80}
                      width={200}
                      style={{ maxHeight: "80px", maxWidth: "100%", objectFit: "contain" }}
                    />
                  )}
                </div>
              </div>

              <p>{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Client Signature"}</b>
              </p>

              {""}
            </Col>
          </Row>
        </PremiumCard>

        {/* Snackbar */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000} // Adjust the duration as needed
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={
              snackbarMessage?.includes("successful") ? "success" : "error"
            }
            onClose={handleCloseSnackbar}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>

        <LoadingModal open={open} handleClose={handleClose} />

        {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}

        {isShare && (
          <></>
        )}
      </PremiumPageLayout>

      <PrintComponent>
        <DeliveryReceiptDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>
    </>
  );
};
export default DeliveryReceiptPage;
